import { mountDialogUIReactComponent } from '../../ui_platform/mountDialogUIReactComponent.tsx';
import { PlayerEditProfileDialogContainer } from './PlayerEditProfileDialogContainer.tsx';
import { BotEditProfileDialogContainer } from './BotEditProfileDialogContainer.tsx';
const openPlayerEditProfileDialog = mountDialogUIReactComponent(PlayerEditProfileDialogContainer);
const openBotEditProfileDialog = mountDialogUIReactComponent(BotEditProfileDialogContainer);
export const showPlayerEditProfileDialog = (params, activeTab)=>{
    openPlayerEditProfileDialog({
        selectColorAction: params.selectColorAction,
        selectedColor: params.selectedColor,
        initialTab: activeTab,
        reopen: (reopenTab)=>showPlayerEditProfileDialog(params, reopenTab)
    });
};
export const showBotEditProfileDialog = (params)=>{
    openBotEditProfileDialog({
        username: params.username,
        selectColorAction: params.selectColorAction,
        selectedColor: params.selectedColor
    });
};
